import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation, Trans } from 'react-i18next';

import { makeGetTask } from '../selectors/tasks';

import Popout from './popout';
import ProjectName from 'components/project-name';
import TaskSelector from 'components/TaskSelector';
import ProjectSelector from 'components/ProjectSelector';

import IconClose from '../icons/icon-close';
import IconArrowDown from '../icons/icon-arrow-down';

class SelectTaskPopout extends PureComponent {
    static defaultProps = {
        withProjectSelect: true
    };

    state = {
        popoutVisible: false,
        selectingProject: false,
        projectId: this.props.projectId
    }

    handlePopoutOpenClick = () => {
        this.show();
    }

    handlePopoutCloseClick = () => {
        this.popoutCtrl.hide();
    }

    handlePopoutShow = () => {
        this.setState({
            popoutVisible: true
        });

        this.props.onShow && this.props.onShow();
    }

    handlePopoutHide = () => {
        this.setState({
            popoutVisible: false,
            selectingProject: false
        });

        this.props.onHide && this.props.onHide();
    }

    handleTaskUntie = () => {
        this.props.onUntie && this.props.onUntie();

        this.popoutCtrl.hide();
    }

    handleTaskSelect = taskId => {
        this.props.onSelect(taskId);

        this.popoutCtrl.hide();
    }

    handleProjectChangeClick = () => {
        this.setState({
            selectingProject: true
        });
    }

    handleProjectSelect = projectId => {
        this.setState({
            projectId,
            selectingProject: false
        });
    }

    show() {
        this.popoutCtrl.show();
    }

    setPopoutCtrl = ctrl => this.popoutCtrl = ctrl;

    componentDidMount() {
        const ctrl = {
            show: () => {
                this.popoutCtrl && this.popoutCtrl.show();
            }
        };

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = ctrl;
            } else {
                this.props.provideController && this.props.provideController(ctrl);
            }
        }
    }

    componentWillUnmount() {
        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = null;
            } else {
                this.props.provideController && this.props.provideController(null);
            }
        }
    }

    render() {
        const { t } = this.props;

        // TODO: Add content loader
        const children = this.props.children && React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                className: child.props.className + (this.state.popoutVisible ? ' selected disable-tooltip' : ''),
                onClick: this.handlePopoutOpenClick
            });
        });

        return (
            <React.Fragment>
                { children }

                <Popout
                    className="no-arrow xxsmall popout-resource-selector"
                    provideController={this.setPopoutCtrl}
                    onShow={this.handlePopoutShow}
                    onHide={this.handlePopoutHide}
                    xAlign={this.props.xAlign}
                    defaultXPosition={this.props.defaultXPosition}
                    closeOnEveryClick={true}
                    inline={this.props.inline}
                >
                    <div className="popout-head">
                        {this.props.title}

                        <button className="btn btn-icon btn-small popout-close" onClick={this.handlePopoutCloseClick}>
                            <IconClose />
                        </button>
                    </div>

                    <div className="popout-main">
                        {
                            this.state.selectingProject ? (
                                <ProjectSelector selected={this.state.projectId} onSelect={this.handleProjectSelect} />
                            ) : (
                                <React.Fragment>
                                    {
                                        this.props.withProjectSelect ? (
                                            <div className="popout-resource-selector-extra">
                                                <Trans
                                                    i18nKey="project:In Project"
                                                    components={{
                                                        strong: <strong className="clickable text-colored" onClick={this.handleProjectChangeClick} />,
                                                        ProjectName: <ProjectName id={this.state.projectId} />,
                                                        IconArrowDown: <IconArrowDown size="14px" />
                                                    }}
                                                />
                                            </div>
                                        ) : null
                                    }

                                    <TaskSelector projectId={this.state.projectId} selected={this.props.selected} onSelect={this.handleTaskSelect} excluded={this.props.excluded} />
                                </React.Fragment>
                            )
                        }

                    </div>

                    {
                        this.props.selected ? (
                            <div className="popout-foot">
                                <span className="action" onClick={this.handleTaskUntie}>{ t('actions.Remove Dependency') }</span>
                            </div>
                        ) : null
                    }
                </Popout>
            </React.Fragment>
        );
    }
}

const makeMapStateToProps = () => {
    const getTask = makeGetTask();

    return ({ tasks }, ownProps) => ({
        selectedTask: ownProps.selected && getTask(tasks.items, ownProps.selected)
    });
}

export default connect(makeMapStateToProps)(withTranslation(['task', 'project'])(SelectTaskPopout));
